import React, { useEffect, useState } from "react";
import manager from "../../Manager";
import './index.scss';
import {
    IconPlusSmallWhite,
    IconCross
} from '../../icons/svgs';

function RepeaterControl({ structure, controlKey, saveValue, defaultValue, structureKey, selectedSlide, selectedSlideIndex, prefixKey, showModalCrop }) {

    const [controlValue, setControlValue] = useState(defaultValue ?? []);

    const parentKey = controlKey;
    const maxFieldSet = structure.maxOption;
    const repeaterType = structure.repeaterType;
    const relatedRequireds = structure.relatedRequired;
    // console.log('RepeaterControl:relatedRequireds',relatedRequireds);

    // console.log('controlValue ',controlValue);
    // console.log('defaultValue', defaultValue);

    const structToDefaultValue = (struct) => {
        let result = {};
        for (let key in struct) {
            let type = struct[key].type;    //text
            let value = '';
            if (type === 'repeater') {
                value = [];
            }
            result[key] = value;
        }
        return result;
    }

    const addGroup = (e) => {
        if (controlValue.length === maxFieldSet) {
            return false;
        }
        setControlValue([...controlValue, structToDefaultValue(structure.struct)]);

        saveValue([...controlValue, structToDefaultValue(structure.struct)]);
    }
    const removeGroup = (item) => {
        const newControlValue = controlValue.filter((prevItem) => prevItem !== item);
        setControlValue(newControlValue);
        saveValue(newControlValue);
        reRender();
    }
    const saveFieldValue = (index, repeaterKey, value) => {
        controlValue[index][repeaterKey] = value;
        const newControlValue = [...controlValue];
        setControlValue(newControlValue);
        saveValue(newControlValue);
    }

    const reRender = () => {
        setControlValue((prevState) => {
            return [...prevState];
        });
    }
    const moveGroup = (from, to) => {
        let newControlValue = [...controlValue];
        let temp = newControlValue[to];
        newControlValue[to] = newControlValue[from];
        newControlValue[from] = temp;
        setControlValue(newControlValue);
        saveValue(newControlValue);
    }

    useEffect(() => {
        if (typeof defaultValue !== 'undefined') {
            setControlValue(defaultValue);
        } else {
            setControlValue([]);
        }
    }, [defaultValue]);

    return (
        <div className={`tbcourse-editor-control-repeater ` + (repeaterType ?? '')}>
            {controlValue.map((item, indexData) => (
                <div className="tbcourse-editor-control-repeater-group" data-key={`repeater-group-${structureKey}-${indexData}`} key={`repeater-group-${structureKey}-${indexData}`}>
                    <div className="tbcourse-editor-control-repeater-group-header">
                        {/* <div className="container-fluid p-0"> */}
                        {/* <div className="row"> */}
                        {/* <div className="col-sm-9">
                                    <strong>{typeof structure.label !== 'undefined' ? structure.label + ' ' + (indexData+1) : structureKey + ' ' + (indexData+1)}</strong>
                                </div> */}
                        {/* <div className="col-sm-3 text-right"> */}
                        {/* {indexData!==0 && <button type="button" onClick={()=> moveGroup(indexData, indexData-1)}>Up</button>}
                                    {indexData!==(controlValue.length-1) && <button type="button" onClick={()=> moveGroup(indexData, indexData+1)}>Down</button>} */}
                        <button type="button" className="btn btn-remove remove" onClick={() => removeGroup(item)}>
                            <IconCross />
                        </button>
                        {/* </div> */}
                        {/* </div> */}
                        {/* </div> */}
                    </div>
                    <div className="tbcourse-editor-control-repeater-group-fieldset">
                        {Object.keys(structure.struct).map((key, index) => {
                            const repeaterStruct = structure.struct[key];
                            const repeaterKey = key;
                            return (
                                <div className="tbcourse-editor-control-repeater-group-field" data-key={`'repeater-group-field-${parentKey}-${structureKey}-${indexData}-${index}`} key={`'repeater-group-field-${parentKey}-${structureKey}-${indexData}-${index}`}>
                                    <div className="tbcourse-editor-control-item">
                                        <div className="tbcourse-editor-control-item-label">
                                            {repeaterStruct.label}
                                        </div>
                                        <div className="tbcourse-editor-control-item-control">
                                            {/* {console.log(parentKey + '-' + structureKey+'-' + indexData + '-' + repeaterKey)} */}
                                            {manager.createControl(repeaterKey, selectedSlide, repeaterStruct, controlValue[indexData][repeaterKey], parentKey + '-' + structureKey + '-' + indexData + '-' + repeaterKey, reRender, (value) => {
                                                return saveFieldValue(indexData, repeaterKey, value);
                                            }, controlValue[indexData][repeaterKey], showModalCrop)}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}

            {(controlValue.length < maxFieldSet) ? (<button type="button" className="btn btn-add-option" onClick={addGroup}>Add Option <IconPlusSmallWhite /></button>) : ''}
        </div>
    );
}

export default RepeaterControl;
